/*
  BluFood Startseite (bf C4) – Reiter fuer sections/bf-product-tabs.liquid
  Ohne JavaScript stehen alle Reiter-Inhalte untereinander (mit Zwischenueberschrift).
  Tastatur: Pfeil links/rechts, Pos1, Ende (WAI-ARIA Tabs, automatische Aktivierung).
*/

class BfTabs extends HTMLElement {
  connectedCallback () {
    if (this._ready) return
    this._ready = true
    this.list = this.querySelector('[data-bf-tablist]')
    this.tabs = [...this.querySelectorAll('[role="tab"]')]
    this.panels = [...this.querySelectorAll('[data-bf-panel]')]
    if (!this.list || this.tabs.length < 2) return
    this.list.hidden = false
    this.classList.add('is-enhanced')
    this.list.addEventListener('click', (e) => {
      const tab = e.target.closest('[role="tab"]')
      if (!tab) return
      this.select(tab, false)
      // R50: angetippten Reiter ganz ins Bild holen (nur waagerecht)
      const l = this.list
      const left = tab.offsetLeft - (l.clientWidth - tab.offsetWidth) / 2
      l.scrollTo({ left: Math.max(0, left), behavior: 'smooth' })
    })
    // R50: Verlauf und Pfeil, solange rechts weitere Reiter stehen
    this.rail = this.querySelector('[data-bf-rail]')
    if (this.rail) {
      const upd = () => this.updateRail()
      this.list.addEventListener('scroll', upd, { passive: true })
      window.addEventListener('resize', upd)
      const next = this.querySelector('[data-bf-tabs-next]')
      if (next) next.addEventListener('click', () => this.list.scrollBy({ left: Math.round(this.list.clientWidth * 0.7), behavior: 'smooth' }))
      requestAnimationFrame(upd)
    }
    this.list.addEventListener('keydown', (e) => this.onKey(e))
    const current = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0]
    this.select(current, false)
    // Theme-Editor: ausgewaehlten Reiter-Block anzeigen
    document.addEventListener('shopify:block:select', (e) => {
      const tab = this.tabs.find((t) => t.id === 'BfTab-' + e.detail.blockId)
      if (tab) this.select(tab, false)
    })
  }

  updateRail () {
    const l = this.list
    const max = l.scrollWidth - l.clientWidth
    this.rail.classList.toggle('is-more-right', max > 2 && l.scrollLeft < max - 2)
    this.rail.classList.toggle('is-more-left', max > 2 && l.scrollLeft > 2)
  }

  onKey (e) {
    const i = this.tabs.indexOf(document.activeElement)
    if (i < 0) return
    let next = null
    if (e.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length]
    else if (e.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length]
    else if (e.key === 'Home') next = this.tabs[0]
    else if (e.key === 'End') next = this.tabs[this.tabs.length - 1]
    if (!next) return
    e.preventDefault()
    this.select(next, true)
  }

  select (tab, focus) {
    this.tabs.forEach((t) => {
      const on = t === tab
      t.setAttribute('aria-selected', String(on))
      t.tabIndex = on ? 0 : -1
    })
    const id = tab.getAttribute('aria-controls')
    this.panels.forEach((p) => { p.hidden = p.id !== id })
    if (focus) {
      tab.focus()
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' })
    }
  }
}

if (!customElements.get('bf-tabs')) customElements.define('bf-tabs', BfTabs)
